import type { SegmentsOptions } from '@openx/types/targeting/customVariables';

type SegmentOptionResult = {
  id?: string | null;
  name?: string | null;
  extra?: unknown;
} | null;

const toOptionalNumber = (value: unknown) => {
  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : undefined;
  }
  if (typeof value === 'string' && value.trim() !== '') {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : undefined;
  }
  return undefined;
};

const toOptionalString = (value: unknown): string | undefined =>
  typeof value === 'string' && value.trim() !== '' ? value : undefined;

export const mapSegmentsOptions = (options: ReadonlyArray<SegmentOptionResult | undefined>): SegmentsOptions =>
  options.reduce((acc, option) => {
    if (option?.id && option?.name) {
      const extra = option.extra as Record<string, unknown> | undefined;
      acc.push({
        id: option.id,
        name: option.name,
        provider_name: typeof extra?.provider_name === 'string' ? extra.provider_name : '',
        price_pom: toOptionalNumber(extra?.price_pom),
        price_cpm: toOptionalNumber(extra?.price_cpm),
        description: extra?.description as string | undefined,
        contextual_provider: toOptionalString(extra?.provider_id) ?? toOptionalString(extra?.contextual_provider),
        exchange_partner_id: extra?.exchange_partner_id as string | undefined,
      });
    }

    return acc;
  }, [] as SegmentsOptions);
